import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import userbase from 'userbase-js'
import { AccountFields } from './new-person/AccountFields'
import { SafetyFields } from './new-person/SafetyFields'
import { VaccineFields } from './new-person/VaccineFields'
import { Button } from '../components/buttons'

export const NewPerson = ({ user }) => {
  const history = useHistory()

  const [submitButton, setSubmitButton] = useState()

  const [newPersonForm, setNewPersonForm] = useState({
    firstName: '',
    lastName: '',
  })

  const handleNewPersonInputChange = (event) =>
    setNewPersonForm({
      ...newPersonForm,
      [event.target.name]: event.target.value,
    })

  const DATABASE_NAME = 'bubble'

  useEffect(() => {
    if (user) {
      userbase.openDatabase({ databaseName: DATABASE_NAME, changeHandler })
    }
  }, [user])

  const changeHandler = (items) => {
    console.log(items)
  }

  const handleNewPersonSubmit = (event) => {
    event.preventDefault()
    userbase.insertItem({ databaseName: DATABASE_NAME, item: newPersonForm })

    switch (submitButton) {
      case 'toDashboard':
        history.push({ pathname: '/' })
        break
      case 'addMore':
        setNewPersonForm({
          firstName: '',
          lastName: '',
        })
        history.push({ pathname: '/new' })
        window.scrollTo(0, 0)
        break
      default:
        history.push({ pathname: '/' })
        break
    }
  }

  const handleToDashboardClick = () => {
    setSubmitButton('toDashboard')
  }

  const handleAddMoreClick = () => {
    setSubmitButton('addMore')
  }

  return (
    <div className="container-md py-64">
      <h2 className="text-30 text-purple-dark mb-20">
        Add People to Your Bubble
      </h2>
      <p className="mb-20">
        Describe the safety practices and habits for the people in your social
        circle, as best you can.
      </p>
      <p className="mb-64">
        You can add more people at the bottom of the form, or add others later.
      </p>
      <form onSubmit={handleNewPersonSubmit} id="new-person">
        <AccountFields
          form={newPersonForm}
          handleChange={handleNewPersonInputChange}
        />
        <SafetyFields />
        <VaccineFields />
      </form>

      <div className="flex flex-col sm:flex-row">
        <Button
          onClick={handleToDashboardClick}
          className="bg-purple-light border-2 border-purple-light text-white rounded-10 mb-20 sm:mb-0 sm:mr-20"
          type="submit"
          value="save"
          form="new-person"
        >
          Save and go to dashboard
        </Button>
        <Button
          onClick={handleAddMoreClick}
          className="border-2 border-purple-dark text-purple-dark rounded-10"
          type="submit"
          value="add"
          form="new-person"
        >
          Add More People
        </Button>
      </div>
    </div>
  )
}
